export enum VehicleCalendarVariantEnum {
  NoCalendar = "Hide Calender Icon",
  UnavailableCalendar = "Cannot Show Vehicle Availability",
  AvailableCalendar = "Show Vehicle Availability",
  DisabledCalendar = "Calendar Disabled Due to Insufficient Input Data",
}
